<template>
<header>
    <div class="inr flex">
        <figure class="logo" @click="goToLink('/home')">
            <img src="@/assets/image/logo-full.png" alt="휴식 로고">
        </figure>
        <div class="header-right">
            <div class="header-user" @click="goToLink('/information')">
                <figure><img src="@/assets/image/icon-header-user.png" alt="마이페이지"></figure>
                <span class="user-name">{{$store.state.userInfo.name}}</span>
            </div>
            <!-- <div class="header-notification active">
                <figure>
                    <img class="active" src="@/assets/image/icon-header-notification-default.png" alt="알림">
                    <img class="default" src="@/assets/image/icon-header-notification-active.png" alt="알림">
                </figure>
            </div> -->
        </div>
    </div>
</header>
</template>

<script>
export default {
    data() {
        return {
            sticky: "",
            header: "",
        };
    },
    mounted() {
        this.header = document.querySelector("header");
        this.sticky = this.header.offsetTop;

        this.headerSticky();

        window.onscroll = () => {
            this.headerSticky();
        };
    },
    methods: {
        headerSticky() {
            if (window.pageYOffset > this.sticky) {
                this.header.classList.add("header-sticky");
            } else {
                this.header.classList.remove("header-sticky");
            }
        },
        goToLink(path) {
            if (path !== this.$route.path) {
                this.$router.push({
                    path: path
                });
            }
        }
    }
};
</script>
